// extracted by mini-css-extract-plugin
module.exports = {"topPadding":"Logo_topPadding__32VUw","loneImage":"Logo_loneImage__3CGwD"};